import { Modal } from '@st-operations/uikit/src/v2'
import React, { useEffect, useState } from 'react'

import EventFeedsWizardWelcome from './welcome'
import EventFeedsWizardTerms from './terms'
import EventFeedsWizardCategories from './categories'
import EventFeedsWizardGeo from './geos'
import EventFeedsWizardAttributes from './attributes'
import EventFeedsWizardDefaultFilters from './default-filters'
import EventFeedsWizardDomain from './domains'
import { getEventsSchema } from '_services/data-explorer'

import './styles.scss'

export const TYPE_PREBUILT_ATTRIBUTES_V2 = 'prebuilt_attributes_v2'

const EventFeedsWizard = ({
  isOpen,
  onClose,
  onFinish,
  namelessFeed,
  dontShowCheckEnabled,
  onCreateWithoutWizard,
}) => {
  const [step, setStep] = useState(1)
  const [feedName, setFeedName] = useState()
  const [type, setType] = useState()
  const [client, setClient] = useState()
  const [terms, setTerms] = useState([])
  const [checked, setChecked] = useState([])
  const [geos, setGeos] = useState([])
  const [attributes, setAttributes] = useState([])
  const [domains, setDomains] = useState([])
  const [isSdf, setIsSdf] = useState(true)
  const [removeBots, setRemoveBots] = useState(true)
  const [sources, setSources] = useState(true)
  const [cgActions, setCgActions] = useState(true)
  const [dontShowMore, setDontShowMore] = useState(() => {
    const localData = localStorage.getItem('do_not_show_wizard')
    return JSON.parse(localData)
  })
  const [cumulativeFilters, setCumulativeFilters] = useState([])

  const result = {
    name: feedName,
    type,
    client,
    attributes,
    filters: [
      ...(terms.length > 0 ? [{ key: 'kecc', operator: 'in', value: terms }] : []),
      ...(checked.length > 0 ? [{ key: 'categories', operator: 'in', value: checked }] : []),
      ...(geos.length > 0 ? [{ key: 'geo_iso', operator: 'in', value: geos }] : []),
      ...(domains.length > 0 ? [{ key: 'domain', operator: 'similar_to', value: domains }] : []),
      ...(isSdf ? [{ key: 'sdf', operator: 'equals', value: true }] : []),
      ...(removeBots ? [{ key: 'bot', operator: 'equals', value: true }] : []),
      ...(sources ? [{ key: 'source', operator: 'in', value: ['sharethis'] }] : []),
      ...(cgActions ? [{ key: 'cg_actions', operator: 'not_in', value: ['blocklist'] }] : []),
    ],
  }

  const increaseStep = () => setStep(step + 1)
  const decreaseStep = () => setStep(step - 1)
  const clear = async () => {
    setStep(1)
    setTerms([])
    setChecked([])
    setGeos([])
    setIsSdf(true)
    setRemoveBots(true)
    setSources(true)
    setCgActions(true)
    setCumulativeFilters([])

    if (type !== TYPE_PREBUILT_ATTRIBUTES_V2) {
      const schema = await getEventsSchema()
      setAttributes(schema?.attributes?.default || [])
    } else {
      setAttributes([])
    }
  }

  useEffect(() => {
    clear()
  }, [isOpen])

  useEffect(() => {
    localStorage.setItem('do_not_show_wizard', `${dontShowMore}`)
  }, [dontShowMore])

  const removeTermsCumulativeFilters = () => {
    setCumulativeFilters(() => cumulativeFilters.filter((f) => f.key !== 'kecc'))
  }

  const removeCategoriesCumulativeFilters = () => {
    setCumulativeFilters(() => cumulativeFilters.filter((f) => f.key !== 'categories'))
  }

  const removeGeosCumulativeFilters = () => {
    setCumulativeFilters(() => cumulativeFilters.filter((f) => f.key !== 'geo_iso'))
  }

  const removeDomainsCumulativeFilters = () => {
    setCumulativeFilters(() => cumulativeFilters.filter((f) => f.key !== 'domain'))
  }

  return (
    <Modal
      className="st-modal--no-click-out"
      isOpen={isOpen}
      onClose={onClose}
      style={{ padding: 0 }}
      classes={{
        content: 'event-feeds-wizard__modal-content',
        childWrapper: 'event-feeds-wizard__modal-child-wrapper',
        innerWrapper: 'event-feeds-wizard__modal-inner-wrapper',
        header: 'event-feeds-wizard__modal-header',
      }}
      currentStep={step}
    >
      <EventFeedsWizardWelcome
        namelessFeed={namelessFeed}
        onCreateWithoutWizard={() => onCreateWithoutWizard(result)}
        onSkip={onClose}
        onStartClick={() => {
          if (type === TYPE_PREBUILT_ATTRIBUTES_V2) {
            const newResult = {
              ...result,
              attributes: undefined,
              aggregations: undefined,
              filters: undefined,
            }
            onFinish(newResult)
          } else {
            increaseStep()
          }
        }}
        dontShowMore={dontShowMore}
        onDontShowMoreChange={(e) => setDontShowMore(e.target.checked)}
        dontShowCheckEnabled={dontShowCheckEnabled}
        feedName={feedName}
        onFeedNameChange={setFeedName}
        client={client}
        onClientChange={setClient}
        type={type}
        onTypeChange={setType}
      />
      <If condition={type !== TYPE_PREBUILT_ATTRIBUTES_V2}>
        <EventFeedsWizardTerms
          terms={terms}
          onTermsChange={setTerms}
          onSkip={() => {
            setTerms([])
            removeTermsCumulativeFilters()
            increaseStep()
          }}
          onAddTerms={increaseStep}
          onBackClick={() => {
            removeTermsCumulativeFilters()
            decreaseStep()
          }}
          cumulativeFilters={cumulativeFilters}
          onCumulativeFiltersChange={(filters) => setCumulativeFilters(filters)}
        />
        <EventFeedsWizardCategories
          checked={checked}
          onCheckedChange={setChecked}
          onSkip={() => {
            setChecked([])
            removeCategoriesCumulativeFilters()
            increaseStep()
          }}
          onAddCategories={increaseStep}
          onBackClick={() => {
            removeCategoriesCumulativeFilters()
            decreaseStep()
          }}
          cumulativeFilters={cumulativeFilters}
          onCumulativeFiltersChange={(filters) => setCumulativeFilters(filters)}
        />
        <EventFeedsWizardGeo
          geos={geos}
          onGeosChange={setGeos}
          onSkip={() => {
            setGeos([])
            removeGeosCumulativeFilters()
            increaseStep()
          }}
          onAddGeos={increaseStep}
          onBackClick={() => {
            removeGeosCumulativeFilters()
            decreaseStep()
          }}
          cumulativeFilters={cumulativeFilters}
          onCumulativeFiltersChange={(filters) => setCumulativeFilters(filters)}
        />
        <EventFeedsWizardAttributes
          attributes={attributes}
          onAttributesChange={setAttributes}
          onSkip={() => {
            setAttributes([])
            increaseStep()
          }}
          onAddAttributes={increaseStep}
          onBackClick={decreaseStep}
          cumulativeFilters={cumulativeFilters}
          onCumulativeFiltersChange={(filters) => setCumulativeFilters(filters)}
        />
        <EventFeedsWizardDomain
          domains={domains}
          onDomainsChange={setDomains}
          onSkip={() => {
            setDomains([])
            removeDomainsCumulativeFilters()
            increaseStep()
          }}
          onAddDomains={increaseStep}
          onBackClick={() => {
            removeDomainsCumulativeFilters()
            decreaseStep()
          }}
          cumulativeFilters={cumulativeFilters}
          onCumulativeFiltersChange={(filters) => setCumulativeFilters(filters)}
        />
        <EventFeedsWizardDefaultFilters
          isSdf={isSdf}
          onIsSdfChange={setIsSdf}
          removeBots={removeBots}
          onRemoveBotsChange={setRemoveBots}
          sources={sources}
          onSourcesChange={setSources}
          cgActions={cgActions}
          onCgActionsChange={setCgActions}
          onSkip={() => {
            setIsSdf(false)
            setRemoveBots(false)
            setSources(false)
            setCgActions(false)
            onFinish(result)
            onClose()
          }}
          onGoToFeed={() => {
            onFinish(result)
            onClose()
          }}
          onBackClick={decreaseStep}
        />
      </If>
    </Modal>
  )
}

export default EventFeedsWizard
